import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { allottedTimeFactory } from "@/components/Provider/ScheduleAvailability/constants";
import { AptihealthIcon } from "@/component-library/Icons/components/AptihealthIcon";
import { BhsIcon } from "@/component-library/Icons/components/BhsIcon";
import Button from "@/components/UI/Button";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getCanStartCall } from "@/features/calendar/utils/general";
import { ICON_SIZES, ICON_TYPES } from "@/constants/icons";
import images from "@/utils/images";
import { IntakeIcon } from "@/component-library/Icons/components/IntakeIcon";
import { PrescriberIcon } from "@/component-library/Icons/components/PrescriberIcon";
import { useCurrentUTCTime } from "@/utils/hooks/useCurrentTime";

import { buildCallDate, buildCallTimeInfo, buildCallTitle } from "../../helpers/call-meta";
import "../../styles.scss";

export function NextSessionWidget(props) {
  const { scheduleList } = props;
  const history = useHistory();
  const [nextSession, setNextSession] = useState(null);
  const { currentTime } = useCurrentUTCTime({ interval: 5000 });

  useEffect(() => {
    if (scheduleList && scheduleList.length) {
      setNextSession(scheduleList[0]);
    } else {
      setNextSession(null);
    }
  }, [scheduleList]);

  const startCall = (callId) => {
    history.push(`/app/video-call?callId=${callId}`);
  };

  const getCallIcon = (providerRole) => {
    switch (providerRole) {
      case "BEHAVIORAL":
        return (
          <BhsIcon className="IconWhite" iconSize={ICON_SIZES.LARGE} iconType={ICON_TYPES.CIRCLE} />
        );

      case "BEHAVIORAL_INTAKE":
        return (
          <IntakeIcon
            className="IconWhite"
            iconSize={ICON_SIZES.LARGE}
            iconType={ICON_TYPES.CIRCLE}
          />
        );

      case "PRESCRIBE":
        return (
          <PrescriberIcon
            className="IconWhite"
            iconSize={ICON_SIZES.LARGE}
            iconType={ICON_TYPES.CIRCLE}
          />
        );

      default:
        return (
          <AptihealthIcon
            className="IconWhite"
            iconSize={ICON_SIZES.LARGE}
            iconType={ICON_TYPES.CIRCLE}
          />
        );
    }
  };

  const renderNoNextSession = () => {
    return (
      <div className="text-center mt-lg-4 mt-md-2 mt-0 mx-4">
        <div className="fs-16 tw:font-bold">No Session Scheduled</div>
        <div className="fs-14 tw:leading-4.5">
          Once scheduled, the date and time of your next session will appear here.
        </div>
      </div>
    );
  };

  const renderNextSession = (nextSession) => {
    const {
      allotted_time,
      callId,
      event_type,
      patient_username,
      provider_name,
      provider_role,
      timestamp,
    } = nextSession;
    const allottedTime = allotted_time ? allotted_time : allottedTimeFactory(event_type);

    return (
      <>
        <div className="d-flex mt-2">
          <div className="pr-2">{getCallIcon(provider_role)}</div>
          <div>
            <div className="fs-16 mb-1 tw:leading-4.5 tw:font-bold">
              {buildCallTitle(provider_role, event_type)} with{" "}
              <span style={{ whiteSpace: "nowrap" }}>{provider_name}</span>
            </div>
            <div className="fs-14 tw:leading-3.75">
              {buildCallDate(timestamp)} {window.innerWidth > 1200 ? "· " : " "}
              <span style={{ whiteSpace: "nowrap" }}>
                {buildCallTimeInfo(timestamp, allottedTime)}
              </span>
              <div>{allottedTime} minutes</div>
            </div>
          </div>
        </div>

        <div className="d-flex mt-2 pb-lg-0 pb-2 tw:justify-center">
          {getCanStartCall(currentTime, timestamp, allottedTime) && (
            <Button
              className="Btn Btn--pri Btn-xs Btn-xs-2 Btn-rounded Btn-otl-white Btn-transparent tw:font-bold"
              onClick={() => startCall(callId, provider_name, patient_username)}
              style={{ margin: 0, textDecoration: "none" }}
            >
              <div className="txt-white d-flex">
                <img alt="" src={images("./icons/common/start-video.svg")} />
                <div className="ml-1 mt-1">Start Visit</div>
              </div>
            </Button>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <div
        className="dashboard-widget-card dashboard-widget-card-sm dashboard-widget-card-pri px-lg-3 px-2 py-2 text-white"
        {...getAutomationDataAttr("patient-home-next-session-widget")}
      >
        <div className="fs-lg-22 fs-20 mb-1 d-inline-flex tw:font-bold">Your Next Session</div>
        {!nextSession && renderNoNextSession()}
        {nextSession && renderNextSession(nextSession)}
      </div>
    </>
  );
}
